import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { ReportsApi, MainAppApi, EngagementApi } from '_services'
import { authReducer } from '_reducers'

export const store = configureStore({
  reducer: {
    [ReportsApi.reducerPath]: ReportsApi.reducer,
    [MainAppApi.reducerPath]: MainAppApi.reducer,
    [EngagementApi.reducerPath]: EngagementApi.reducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(ReportsApi.middleware)
      .concat(MainAppApi.middleware)
      .concat(EngagementApi.middleware),
})
setupListeners(store.dispatch)
